export const villeData = [
  {
    ville: "Marseille",
    slug: "marseille",
    cp: "13001",
  },
  {
    ville: "Lyon",
    slug: "lyon",
    cp: "69001",
  },
  {
    ville: "Paris",
    cp: "75001",
    slug: "paris",
  },
  {
    ville: "Montpellier",
    slug: "montpellier",
    cp: "34000",
  },
  {
    ville: "Strasbourg",
    slug: "strasbourg",
    cp: "67000",
  },
  {
    ville: "Toulouse",
    slug: "toulouse",
    cp: "31000",
  },
  {
    ville: "Bordeaux",
    cp: "33000",
    slug: "bordeaux",
  },
  {
    ville: "Nantes",
    slug: "nantes",
    cp: "44000",
  },
  {
    ville: "Grenoble",
    slug: "grenoble",
    cp: "38000",
  },
  {
    ville: "Rennes",
    slug: "rennes",
    cp: "35000",
  },
  {
    ville: "Lille",
    slug: "lille",
    cp: "59000",
  },
  {
    ville: "Nice",
    slug: "nice",
    cp: "06000",
  },
  {
    ville: "Annecy",
    slug: "annecy",
    cp: "74000",
  },
  {
    ville: "Reims",
    slug: "reims",
    cp: "51100",
  },
  {
    ville: "Rouen",
    slug: "rouen",
    cp: "76000",
  },
  {
    ville: "Tours",
    slug: "tours",
    cp: "37000",
  },
  {
    ville: "Dijon",
    slug: "dijon",
    cp: "21000",
  },
  {
    ville: "Clermont-Ferrand",
    slug: "clermont-ferrand",
    cp: "63000",
  },
  {
    ville: "Metz",
    slug: "metz",
    cp: "57000",
  },
  {
    ville: "Saint-Étienne",
    slug: "saint-etienne",
    cp: "42000",
  },
  {
    ville: "Nancy",
    slug: "nancy",
    cp: "54000",
  },
  {
    ville: "Angers",
    slug: "angers",
    cp: "49000",
  },
  {
    ville: "Brest",
    slug: "brest",
    cp: "29200",
  },
  {
    ville: "Orléans",
    slug: "orleans",
    cp: "45000",
  },
  {
    ville: "Limoges",
    slug: "limoges",
    cp: "87000",
  },
  {
    ville: "Caen",
    slug: "caen",
    cp: "14000",
  },
  {
    ville: "Le Mans",
    slug: "le-mans",
    cp: "72000",
  },
  {
    ville: "Besançon",
    slug: "besancon",
    cp: "25000",
  },
  {
    ville: "Amiens",
    slug: "amiens",
    cp: "80000",
  },
  {
    ville: "Pau",
    slug: "pau",
    cp: "64000",
  },
]

export const loisirs = {
  musee: "musees.svg",
  promenade: "promenade.svg",
  bar: "vie_nocturne.svg",
  alternatif: "culture_alternative.svg",
  concert: "theatre.svg",
  sport: "sports.svg",
  cinema: "cinema.svg",
  musique: "music.svg",
  montagne: "mountain.svg",
  quai: "quai.svg",
  gastronomie: "gastronomie.svg",
  boat: "boat.svg",
  port: "port.svg",
  rugby: "rugby.svg",
  shopping: "shopping.svg",
  ski: "ski.svg",
  machine: "machine.svg",
  beach: "beach.svg",
}

export const transports = {
  bus: "bus.svg",
  tramway: "tramway.svg",
  trottinette: "trottinette.svg",
  tgv: "tgv.svg",
  velo: "velo.svg",
  aeroport: "avion.svg",
  metro: "metro.svg",
  train: "train.svg",
  funiculaire: "funiculaire.svg",
  voiture: "voiture.svg",
  pieton: "walk.svg",
}

export const appartements = {
  Studio: "studio.svg",
  T2: "t2.svg",
}
